<app-tab-menu class="menu"></app-tab-menu>
<div class="content">
	<div class="header">
		<h2>ETL Beheer</h2>
	</div>
	<div class="cards">
		<div class="card">
			<div class="card-header">
				<span>Geplande jobs</span>
			</div>
			<div class="card-content">
				<table>
					<thead>
						<tr>
							<th>Naam</th>
							<th>Schedule</th>
							<th>Status</th>
							<th>Acties</th>
						</tr>
					</thead>
					<tbody>
						@for (cronJob of cronJobs(); track cronJob.uid) {
							<tr>
								<td [appTooltip]="cronJob.description">
									<span class="label">
										{{ cronJob.name }}
									</span>
								</td>
								<td [appTooltip]="cronJob.cronTooltip">
									<span class="label">
										{{ cronJob.schedules.join(", ") }}
									</span>
								</td>
								<td>
									<div class="cron-status" [class.actief]="cronJob.active">
										<span class="bullet"></span>
										<span>{{ cronJob.active ? "Actief" : "Gedeactiveerd" }}</span>
									</div>
								</td>
								<td>
									<div class="actions">
										@if (cronJob.active) {
											<app-button buttonType="primary" [enabled]="authService.developer()" (clickit)="deactivate(cronJob.cronWorkflow)">
												Deactiveer
											</app-button>
										} @else {
											<app-button buttonType="primary" [enabled]="authService.developer()" (clickit)="activate(cronJob.cronWorkflow)">
												Activeer
											</app-button>
										}
										<app-button buttonType="primary" [enabled]="cronJob.lastWorkflow !== undefined" (clickit)="openDetails(cronJob.lastWorkflow!)"> Details </app-button>
									</div>
								</td>
							</tr>
						}
					</tbody>
				</table>
				@if (cronJobs().length === 0) {
					<div class="no-jobs">Geen geplande jobs gevonden.</div>
				}
			</div>
		</div>
		<div class="card">
			<div class="card-header">
				<span>Draaiende & historische jobs</span>
			</div>
			<div class="card-content">
				@for (job of jobs(); track job.uid) {
					<div class="job">
						<div class="cell">
							<span class="name" [class.active]="!job.finishTime">
								{{ job.name }}
							</span>
							<span class="time"> Gestart: {{ job.startTime }} </span>
							@if (job.finishTime) {
								<span class="time"> Afgerond: {{ job.finishTime }} </span>
							}
						</div>
						<app-button buttonType="primary" (clickit)="openDetails(job.workflow)"> Details </app-button>
					</div>
				} @empty {
					<div class="no-jobs">Geen draaiende & historische jobs gevonden.</div>
				}
			</div>
		</div>
	</div>
</div>
@if (authService.developer()) {
	<div class="footer">
		@for (landelijkeTemplate of landelijkeTemplates(); track landelijkeTemplate.uid) {
			<app-button
				[enabled]="!landelijkeTemplate.runningWorkflow"
				(clickit)="startLandelijkeETLJob(landelijkeTemplate.name, landelijkeTemplate.workflowTemplate)"
			>
				{{ landelijkeTemplate.name }} starten
			</app-button>
		}
	</div>
}
